import { useState } from 'react';
import { useSeoMeta } from '@unhead/react';
import { Layout } from '@/components/Layout';
import { GoLiveModal } from '@/components/GoLiveModal';
import { UploadModal } from '@/components/UploadModal';
import { LiveStreamCard, LiveStreamCardSkeleton } from '@/components/LiveStreamCard';
import { useLiveStreams } from '@/hooks/useLiveStreams';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import { LoginArea } from '@/components/auth/LoginArea';

export default function LivePage() {
  const [goLiveOpen, setGoLiveOpen] = useState(false);
  const [uploadOpen, setUploadOpen] = useState(false);
  const { user } = useCurrentUser();
  const { data: streams, isLoading } = useLiveStreams();

  useSeoMeta({
    title: 'Live Streams – Goblinbox',
    description: 'Watch live streams from the Nostr network on Goblinbox.',
  });

  return (
    <Layout onUploadClick={() => setUploadOpen(true)} onGoLiveClick={() => setGoLiveOpen(true)}>
      <div className="px-4 sm:px-6 py-6" style={{ maxWidth: 1400, margin: '0 auto' }}>

        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="flex items-center gap-3 text-2xl font-bold" style={{ color: 'var(--text-primary)' }}>
              <span className="relative flex items-center justify-center w-6 h-6">
                <span
                  className="absolute inline-block w-4 h-4 rounded-full opacity-60"
                  style={{ background: '#f44336', animation: 'ping 1.5s cubic-bezier(0,0,0.2,1) infinite' }}
                />
                <span className="relative inline-block w-3 h-3 rounded-full" style={{ background: '#f44336' }} />
              </span>
              Live Streams
            </h1>
            <p className="text-sm mt-1" style={{ color: 'var(--text-secondary)' }}>
              Live broadcasts from the Nostr network
            </p>
          </div>

          {user ? (
            <button
              onClick={() => setGoLiveOpen(true)}
              className="flex items-center gap-2 px-4 py-2 rounded font-semibold text-sm text-white hover:opacity-90 transition-all"
              style={{ background: '#f44336' }}
            >
              <span className="w-2 h-2 rounded-full bg-white" style={{ animation: 'pulse 1.5s ease-in-out infinite' }} />
              Go Live
            </button>
          ) : (
            <LoginArea className="max-w-[130px]" />
          )}
        </div>

        {/* Grid */}
        {isLoading ? (
          <div className="video-grid">
            {Array.from({ length: 8 }).map((_, i) => <LiveStreamCardSkeleton key={i} />)}
          </div>
        ) : streams && streams.length > 0 ? (
          <div className="video-grid">
            {streams.map(event => (
              <LiveStreamCard key={event.id} event={event} fullWidth />
            ))}
          </div>
        ) : (
          <div className="rounded-xl py-20 px-8 text-center" style={{ border: '2px dashed var(--gb-border)' }}>
            <div className="text-5xl mb-4">📡</div>
            <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>No live streams right now</h2>
            <p className="text-sm mb-6" style={{ color: 'var(--text-secondary)' }}>
              Nobody is streaming at the moment. Check back later or start your own stream!
            </p>
            {user ? (
              <button
                onClick={() => setGoLiveOpen(true)}
                className="px-6 py-2.5 rounded font-semibold text-sm text-white hover:opacity-90 transition-all"
                style={{ background: '#f44336' }}
              >
                Start Streaming
              </button>
            ) : (
              <LoginArea className="max-w-[140px] mx-auto" />
            )}
          </div>
        )}
      </div>

      <GoLiveModal open={goLiveOpen} onClose={() => setGoLiveOpen(false)} />
      <UploadModal open={uploadOpen} onClose={() => setUploadOpen(false)} />
    </Layout>
  );
}
